export default () => {
    return (
        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="text-center">
                <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                    <span className="text-we-are-yellow">We </span>
                    <span className="text-we-are-purple">Are</span>
                </p>
                <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                    Your podcast
                </h2>
                <p className="max-w-2xl my-5 mx-auto text-xl text-gray-100">
                    WE ARE – Personal Training Uden en Schijndel heeft zijn
                    eigen podcast, volg jij ons al op Spotify? Abonneer nu
                    gratis op onze podcast en leer alles over de wereld van
                    voeding en training!
                </p>
            </div>
            <iframe
                style={{
                    borderRadius: "12px",
                }}
                src="https://open.spotify.com/embed/show/6fZh8VEmGWujSOK9Sacn2H?utm_source=generator"
                width="100%"
                height="232"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            ></iframe>
        </div>
    );
};
